const DASHBOARD = {
    POS_TERMINAL_AND_SUBSCRIPTIONS: {
        url: '/dashboard/posTerminalAndSubscriptions',
        queryKey: 'getPosTerminalAndSubscriptionsStats'
    },
    SIM_CARDS: {
        url: '/dashboard/sims',
        queryKey: 'getSimCardsStats'
    },
    CONTRACTS: {
        url: '/dashboard/contracts',
        queryKey: 'getContractsStats'
    },
    SIM_POOLS: {
        url: '/dashboard/simPools',
        queryKey: 'getSimPoolsStats'
    }
};

export default DASHBOARD;